module.exports = __webpack_public_path__ + "static/media/planner.6662c30d.svg";